import { env } from 'utils/envManager/envManager'

import { DAM_IMAGE_PATH } from '../../constants/constants'

interface ImageSrcProps {
	src: string
}

export const getImageSrc = ({ src }: ImageSrcProps): URL => {
	const path = `${DAM_IMAGE_PATH}${src.split('/').at(-1)?.split('?')[0].split('.')[0]}`

	return new URL(path, env.NEXT_PUBLIC_ADOBE_DAM_DOMAIN)
}
